import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";

class VerificationSuccess extends Component {
  state = {};
  render() {
    return (
      <div className="">
        <div className="mainform">
          <p className="forgotPasswordMessage">
            {" "}
            <p
              style={{
                color: "green",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <FontAwesomeIcon size="2x" icon={faCheckCircle} />
            </p>
            You have been successfully subscribed{" "}
          </p>
        
          <p style={{ textAlign: "center" }}>
          You will receive an email once your account is activated.
          </p>
        </div>
      </div>
    );
  }
}

export default VerificationSuccess;



// WEBPACK FOOTER //
// ./src/components/public/VerificationSuccess.js